import { render, staticRenderFns } from "./BaseReport.vue?vue&type=template&id=62fd8d5b"
import script from "./BaseReport.vue?vue&type=script&lang=js"
export * from "./BaseReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports